module.exports = __webpack_public_path__ + "img/arrow-left (1).57c29eab.svg";